export const appName = "PythonSports";
export const appVersion = "3.26.3";
console.log("version : bêta", appVersion);

export const websiteUrl = "https://www.python-sports.com";

export const legalDocUrls = {
  notice: {
    file: `${window.location.origin}/legal/Mentions-Legales-PySports.pdf`,
    site: `${websiteUrl}/legal#notice`,
    embed: `${websiteUrl}/legal?doc=notice&embed=true`,
  },
  terms: {
    file: `${window.location.origin}/legal/Conditions-Generales-PySports.pdf`,
    site: `${websiteUrl}/legal#terms`,
    embed: `${websiteUrl}/legal?doc=terms&embed=true`,
  },
};

export const youtubeUrl = "https://www.youtube.com/@PythonSportsApp";
export const youtubeDemosPlaylistUrl =
  "https://youtube.com/playlist?list=PLKn_jutTiKPmuDEnxijOz-WZLksxUW2TS&si=23FjL7wWglDU4-pk";

export const IFRAME_ORIGIN = window.location.origin;

export const appLanguages = [
  { id: "de", label: "Deutsch", labelShort: "DE" },
  { id: "en", label: "English", labelShort: "EN" },
  { id: "es", label: "Español", labelShort: "ES" },
  { id: "fr", label: "Français", labelShort: "FR" },
  { id: "it", label: "Italiano", labelShort: "IT" },
  { id: "nl", label: "Nederlands", labelShort: "NL" },
];

export function safeArea(side) {
  // for debug
  // if (side === "top") return "10px";
  // if (side === "left") return "10px";
  // if (side === "right") return "10px";
  // if (side === "bottom") return "34px";

  // for prod
  return `env(safe-area-inset-${side})`;
}

export function isPWAInstalled() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    ("standalone" in window.navigator && window.navigator.standalone === true)
  );
}

export function getBrowserName() {
  const ua = navigator.userAgent;
  return /Edg\//.test(ua)
    ? "edge"
    : /Chrome\//.test(ua) && !/Edg\//.test(ua)
      ? "chrome"
      : /Firefox\//.test(ua)
        ? "firefox"
        : /Safari\//.test(ua) && !/Chrome\//.test(ua)
          ? "safari"
          : "other";
}

export function getOsName() {
  const ua = navigator.userAgent;
  return /Android/i.test(ua)
    ? "android"
    : /iPhone|iPad|iPod/i.test(ua)
      ? "ios"
      : /Mac/i.test(ua)
        ? "macos"
        : /Windows/i.test(ua)
          ? "windows"
          : "other";
}

export function getPlatformType() {
  const ua = navigator.userAgent;

  // iPad (anciens + nouveaux)
  if (
    /iPad/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  ) {
    return "tablet";
  }

  // Android
  if (/Android/.test(ua)) {
    return /Mobile/.test(ua) ? "mobile" : "tablet";
  }

  // iPhone
  if (/iPhone|iPod/.test(ua)) {
    return "mobile";
  }

  return "desktop";
}

function _isSafariIOS() {
  const ua = navigator.userAgent;

  const isIOSDevice =
    /iP(ad|hone|od)/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1); // iPadOS en mode desktop

  const isSafariEngine = /WebKit/.test(ua) && !/CriOS|FxiOS|OPiOS/.test(ua); // Exclut Chrome, Firefox, Opera sur iOS

  return isIOSDevice && isSafariEngine;
}

export const isSafariIOS = _isSafariIOS();

function _isTouchDevice() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

export const isTouchDevice = _isTouchDevice();

// ADD HERE

export function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function mergeUniqueByKey(array, items, key = "id") {
  const existing = new Set(array.map((item) => item[key]));

  return [
    ...array,
    ...items.filter((item) => {
      if (existing.has(item[key])) return false;
      existing.add(item[key]);
      return true;
    }),
  ];
}

export const isDateValid = (date) => {
  try {
    const x = new Date(date);
    if (x instanceof Date && !isNaN(x)) {
      return true;
    }
    return false;
  } catch (err) {
    console.error("Error in isDateValid:", err);
    return false;
  }
};

export function numberFormat(
  value,
  lang = "en",
  maximumFractionDigits,
  minimumFractionDigits
) {
  if (value === null || value === undefined) return null;
  return new Intl.NumberFormat(lang, {
    maximumFractionDigits,
    minimumFractionDigits,
  }).format(value);
}

export function addOpacityToRGB(rgbColor, opacity) {
  try {
    // Extraire les valeurs R, G, B à partir de la chaîne rgb(r, g, b)
    const rgbValues = rgbColor.match(/\d+/g);

    const r = rgbValues[0];
    const g = rgbValues[1];
    const b = rgbValues[2];

    // Vérifier que l'opacité est entre 0 et 1
    const alpha = Math.max(0, Math.min(1, opacity));

    // Retourner la couleur au format rgba()
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  } catch (error) {
    console.error("Error in addOpacityToRGB:", error);
    return rgbColor;
  }
}

export function generateUUID() {
  if (import.meta.env.DEV) {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  return crypto.randomUUID();
}

export function isObjectEmpty(obj) {
  return Object.getOwnPropertyNames(obj).length === 0;
}

export const createLinkAndRedirect = (url) => {
  const a = document.createElement("a");
  a.href = url;
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export function capitalizeFirstLetter(str) {
  if (str) {
    try {
      return str
        .split(" ")
        .map((word) => {
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(" ");
    } catch (error) {
      console.error("Error in capitalizeFirstLetter:", error);
      return str;
    }
  }
  return str;
}

export function getDayName(dateStr, locale) {
  let date = new Date(dateStr);
  return date.toLocaleDateString(locale, { weekday: "long" });
}

export const gridOpacity = 0.25;

export const translateSeanceName = (name, lang) => {
  // on reçoit Etat de forme du backend
  if (name === "Etat de forme") {
    if (lang === "en") return "Wellness";
    if (lang === "fr") return "Etat de forme";
    return "Wellness";
  }

  // on reçoit Individuelle du backend
  if (name === "Individuelle") {
    if (lang === "de") return "Individuell";
    if (lang === "en") return "Individual";
    if (lang === "es") return "Individual";
    if (lang === "fr") return "Individuelle";
    if (lang === "it") return "Individuale";
    if (lang === "nl") return "Individuele";
    return "Individual";
  }

  // on reçoit Match du backend
  if (name === "Match") {
    if (lang === "de") return "Spiel";
    if (lang === "en") return "Match";
    if (lang === "es") return "Partido";
    if (lang === "fr") return "Match";
    if (lang === "it") return "Partita";
    if (lang === "nl") return "Wedstrijd";
    return "Individual";
  }

  return name;
};

export const getDateToString = (date, { lang, withYear, withTime }) => {
  try {
    if (!date) return "ND";

    const options = {
      day: "numeric",
      month: "short",
    };

    if (withYear) options.year = "numeric";

    if (withTime) {
      options.hour = "2-digit";
      options.minute = "2-digit";
    }

    return new Date(date).toLocaleDateString(lang, options);
  } catch (error) {
    console.error("Error in getDateToString:", error);
    return "ND";
  }
};

export function getHoursMinutesFormats(minutes) {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  return `${hours}h${remainingMinutes.toString().padStart(2, "0")}`;
}

export const convertDurationStringToMins = (durationString) => {
  if (!durationString) {
    return 0;
  }
  const [hours, minutes] = durationString.split(":").map(Number);
  return hours * 60 + minutes;
};

export const getBackendDateFormat = (date) => {
  const converted = new Date(date);
  const dd = String(converted.getDate()).padStart(2, "0");
  const mm = String(converted.getMonth() + 1).padStart(2, "0");
  const yyyy = String(converted.getFullYear());
  return yyyy + "-" + mm + "-" + dd;
};

export const getSeconds = (hour, min, sec, cent) => {
  return Number(
    `${Number(hour) * 3600 + Number(min) * 60 + Number(sec)}.${String(
      cent
    ).padStart(2, "0")}`
  );
};

export const getSecondsToDurationString = (seconds) => {
  const durationString = new Date(seconds * 1000)
    .toISOString()
    .substring(11, 22);
  const h = durationString.substring(0, 2);
  const m = durationString.substring(3, 5);
  const s = durationString.substring(6, 8);
  const cent = durationString.substring(9, 11);
  return { h, m, s, cent };
};

export function getAge(dateString) {
  try {
    let today = new Date();
    let birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    let m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  } catch (error) {
    console.error("Error in getAge:", error);
    return "ND";
  }
}

export const getRandom = (start, end) =>
  Math.floor(Math.random() * (end - start + 1)) + start;

export function generateDates({
  start,
  end,
  step,
  unit = "days",
  format = "date",
}) {
  if (!start || !end || !step) {
    throw new Error("start, end et step sont requis");
  }

  const result = [];
  let current = new Date(start);
  const endDate = new Date(end);

  const addStep = (date) => {
    const d = new Date(date);
    if (unit === "days") d.setDate(d.getDate() + step);
    if (unit === "hours") d.setHours(d.getHours() + step);
    if (unit === "minutes") d.setMinutes(d.getMinutes() + step);
    return d;
  };

  while (current <= endDate) {
    if (format === "string") {
      const year = String(current.getFullYear());
      const month = String(current.getMonth() + 1).padStart(2, "0");
      const day = String(current.getDate()).padStart(2, "0");
      const date = `${year}-${month}-${day}`;
      result.push(date);
    } else {
      result.push(new Date(current));
    }
    current = addStep(current);
  }

  return result;
}

export function getArrayOfDates(firstDate, secondDate, toString) {
  const dates = [];

  while (firstDate < secondDate) {
    firstDate.setDate(firstDate.getDate() + 1);
    dates.push(new Date(firstDate));
  }

  if (toString) {
    const stringified = dates.map((d) => {
      const year = String(d.getFullYear());
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const date = `${year}-${month}-${day}`;
      return date;
    });

    return stringified;
  }

  return dates;
}

export const roundFloat = (value, round) => {
  if (!round) return Math.round(value * 1e1) / 1e1;
  return Math.round(value * round) / round;
};

export const getRandomFloat = (start, end, round) => {
  const value = Math.random() * (end - start + 1) + start;
  return roundFloat(value, round);
};

export function addDays(date, days) {
  let result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export const getWeekNumber = (date) => {
  const currentDate = new Date(date);
  const startDate = new Date(currentDate.getFullYear(), 0, 1);
  const days = Math.floor((currentDate - startDate) / (24 * 60 * 60 * 1000));
  const weekNumber = Math.ceil(days / 7);
  return weekNumber;
};

export const getYearAndWeekNumber = (date) => {
  const currentDate = new Date(date);
  return (
    String(currentDate.getFullYear()) + "-" + String(getWeekNumber(currentDate))
  );
};

export const searchDate = (date, nextOrPrevious) => {
  let a = new Date(date);
  let b = new Date(a.getTime());
  let c;

  if (nextOrPrevious === "prev") {
    c = b.setDate(a.getDate() - 1);
  } else {
    if (nextOrPrevious === "next") {
      c = b.setDate(a.getDate() + 1);
    }
  }

  let newDate = new Date(c);
  let day = String(newDate.getDate()).padStart(2, "0");
  let month = String(newDate.getMonth() + 1).padStart(2, "0");
  let year = newDate.getFullYear();
  let finallyTheFuckingDate = year + "-" + month + "-" + day;

  return finallyTheFuckingDate;
};

export function secToHour(sec) {
  if (!sec) {
    return "0";
  }

  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec - h * 3600) / 60);
  const mFormat = String(m).padStart(2, "0");
  const s = Math.round(sec - (h * 3600 + m * 60));
  const sFormat = String(s).padStart(2, "0");

  if (h > 0) {
    if (s > 0) {
      return `${h}h${mFormat}m${sFormat}s`; // On colle pour que ça prenne moins de place
    }
    return `${h}h${m > 0 ? `${mFormat}` : ""}`;
  } else {
    if (m > 0) {
      return `${m}m${s > 0 ? `${sFormat}` : ""}`;
    } else {
      return `${s}sec`;
    }
  }
}

export function secToHourYaxis(sec) {
  if (!sec) {
    return "0";
  }

  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec - h * 3600) / 60);
  // const mFormat = String(m).padStart(2, "0");
  const s = Math.round(sec - (h * 3600 + m * 60));
  // const sFormat = String(s).padStart(2, "0");

  if (h > 0) {
    return `${h}h${m > 0 ? "+" : ""}`;
  } else {
    if (m > 0) {
      return `${m}'${s > 0 ? "+" : ""}`;
    } else {
      return `${s}''`;
    }
  }
}

export function minToHour(min) {
  if (!min) {
    return "0";
  }

  const h = Math.floor(min / 60);
  const m = Math.floor(min - h * 60);
  const mFormat = String(m).padStart(2, "0");

  if (h > 0) {
    return `${h}h${m > 0 ? mFormat : ""}`;
  } else {
    return `${m}min`;
  }
}

export function minToHourYaxis(min) {
  if (!min) {
    return "0";
  }

  const h = Math.floor(min / 60);
  const m = Math.floor(min - h * 60);
  // const mFormat = String(m).padStart(2, "0");

  if (h > 0) {
    return `${h}h${m > 0 ? "+" : ""}`;
  } else {
    return `${m}'`;
  }
}

export function calcMedian(arr) {
  const sorted = arr.sort((a, b) => a - b);
  const middle = Math.floor(sorted.length / 2);
  if (sorted.length % 2 === 0) {
    return (sorted[middle - 1] + sorted[middle]) / 2;
  }
  return sorted[middle];
}

export function getDatesInRange(startDate, endDate) {
  const dates = [];
  let currentDate = new Date(startDate);

  while (currentDate <= endDate) {
    dates.push(new Date(currentDate));
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dates;
}

export function getWeekToDateString(yearWeek, format) {
  let [year, week] = yearWeek.split("-").map(Number);

  // Créer une date au 4 janvier de l'année (toujours dans la semaine 1)
  const jan4 = new Date(year, 0, 4);

  // Calculer le premier jour de la semaine 1 (lundi)
  const firstWeekStart = new Date(jan4);
  firstWeekStart.setDate(jan4.getDate() - jan4.getDay() + 1);

  // Calculer le premier jour de la semaine demandée
  const weekStart = new Date(firstWeekStart);
  weekStart.setDate(firstWeekStart.getDate() + (week - 1) * 7);

  // Calculer le dernier jour de la semaine (dimanche)
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekStart.getDate() + 6);

  // Formater les dates au format YYYY-MM-DD
  const formatDate = (date) => {
    return (
      date.getFullYear() +
      "-" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(date.getDate()).padStart(2, "0")
    );
  };

  const weekDates = {
    firstDay: formatDate(weekStart),
    lastDay: formatDate(weekEnd),
  };

  if (format === "period") {
    return weekDates;
  }

  return weekDates.firstDay;
}

export const getWeek = (value, { lang, withYear }) => {
  try {
    const date = new Date(value);
    const period = {
      start: date.getDate(),
      end: new Date(date.setDate(date.getDate() + 6)),
    };

    const endOptions = { month: "short" };

    if (withYear) {
      endOptions.year = "numeric";
    }

    const endFormat = period.end.toLocaleDateString(lang, endOptions);

    return `${period.start}-${period.end.getDate()} ${endFormat}`;
  } catch (error) {
    console.error("Error in getWeek:", error);
    return "ND";
  }
};

// cette méthode modifie le tableau original.
// Si vous voulez préserver le tableau original, vous pouvez créer une copie avant de trier.
export function sortAlphabetically(array, key) {
  try {
    return array.sort((a, b) => {
      // Gérer les cas spéciaux 'null' & 'nd'
      if (a[key].toUpperCase() === "NULL" || a[key].toUpperCase() === "ND")
        return 1; // 'null' va à la fin
      if (b[key].toUpperCase() === "NULL" || b[key].toUpperCase() === "ND")
        return -1; // 'null' va à la fin

      // Comparaison alphabétique standard pour les autres postes
      // localeCompare() pour faire une comparaison alphabétique qui respecte les règles de tri du français.
      // option sensitivity: 'base' dans localeCompare() permet d'ignorer les différences d'accents et de casse.
      return a[key].localeCompare(b[key], "fr", { sensitivity: "base" });
    });
  } catch (error) {
    console.error("Error in sortAlphabetically:", error);
    return array;
  }
}

// const firstNames = [
//   "Lucas",
//   "Theo",
//   "Maxime",
//   "Alex",
//   "Hugo",
//   "Leo",
//   "Matteo",
//   "Nicolas",
//   "Julien",
//   "Sacha",
// ];
// const lastNames = [
//   "Martin",
//   "Durand",
//   "Petit",
//   "Garcia",
//   "Roux",
//   "Morel",
//   "Fournier",
//   "Lopez",
//   "Bertrand",
//   "Garnier",
// ];

// function generateRandomPlayer(index) {
//   const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
//   const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
//   const username = `${firstName.toLowerCase()}.${lastName.toLowerCase()}${index}`;
//   const email = `${username}@demo.club`;

//   return {
//     role: null,
//     first_name: firstName,
//     last_name: lastName,
//     email: email,
//     username: username,
//     pwd1: "demo1234",
//     pwd2: "demo1234",
//   };
// }

// const GeneratePlayers = () => {
//   const [loading, setLoading] = useState(false);

//   const handleClick = async () => {
//     setLoading(true);

//     return api
//       .get(`registration-link/players/`)
//       .then(async (res) => {
//         const link = res.data;
//         const url = link ? new URL(link).searchParams : null;
//         const var1 = url?.get("var1");
//         const sesame = url?.get("sesame");

//         const payloads = Array.from({ length: 30 }).map((_, i) =>
//           generateRandomPlayer(i)
//         );

//         for (const payload of payloads) {
//           try {
//             const res = await axios.post(
//               `${backendUrl}register/${var1}/${sesame}/`,
//               payload
//             );
//           } catch (error) {
//             console.error(
//               `Erreur pour ${payload.username}`,
//               error.response?.data || error.message
//             );
//           }
//         }
//       })
//       .catch((err) => {
//         setLoading(false);
//       });
//   };

//   return (
//     <button onClick={handleClick}>
//       {loading ? "Generating..." : "Generate players"}
//     </button>
//   );
// };
